import { createSlice } from '@reduxjs/toolkit';

import { ERequestApiStatus } from '../../types/appState';
import { SliceActions } from '../types';

const initialState = ERequestApiStatus.Initial;

const socketStatusSlice = createSlice({
  name: 'socketStatus',
  reducers: {
    setSocketStatusPending: () => ERequestApiStatus.Pending,
    setSocketStatusSucceed: () => ERequestApiStatus.Succeed,
    setSocketStatusFailed: () => ERequestApiStatus.Failed,
  },
  initialState,
});

export const socketStatusReducer = socketStatusSlice.reducer;
export const {
  setSocketStatusPending: setSocketStatusPending,
  setSocketStatusFailed: setSocketStatusFailed,
  setSocketStatusSucceed: setSocketStatusSucceed,
} = socketStatusSlice.actions;
export type TSocketStatusActions = SliceActions<typeof socketStatusSlice.actions>;
